import { z } from "zod";
/**
 * Fixed CNA homework schedule. Release datetimes are computed PER BATCH from the
 * batch start date (see lib/homeworkSchedule.ts) - this only declares the packets,
 * their week/day, and source folder. Labs are download-only (requiresSubmission:false).
 */
export const HOMEWORK_PLAN = [
    { packetKey: "wk1-mon", weekKey: "wk1", weekNumber: 1, day: "MON", folder: "week 1", requiresSubmission: true },
    { packetKey: "wk2-mon", weekKey: "wk2", weekNumber: 2, day: "MON", folder: "Week 2.1", requiresSubmission: true },
    { packetKey: "wk2-wed", weekKey: "wk2", weekNumber: 2, day: "WED", folder: "Week 2.2", requiresSubmission: true },
    { packetKey: "wk3-mon", weekKey: "wk3", weekNumber: 3, day: "MON", folder: "WEEK 3.1", requiresSubmission: true },
    { packetKey: "wk3-wed", weekKey: "wk3", weekNumber: 3, day: "WED", folder: "WEEK 3.2", requiresSubmission: true },
    { packetKey: "wk4-mon", weekKey: "wk4", weekNumber: 4, day: "MON", folder: "Week 4.1", requiresSubmission: true },
    { packetKey: "wk4-wed", weekKey: "wk4", weekNumber: 4, day: "WED", folder: "week 4.2", requiresSubmission: true },
    { packetKey: "lab1-sat", weekKey: "lab1", weekNumber: 1, day: "SAT", folder: "Lab 1", requiresSubmission: false },
    { packetKey: "lab2-sat", weekKey: "lab2", weekNumber: 2, day: "SAT", folder: "LAB 2", requiresSubmission: false },
];
/** weekKeys that accept a submission (have a deadline). */
export const SUBMISSION_WEEK_KEYS = ["wk1", "wk2", "wk3", "wk4"];
export const isSubmissionWeek = (weekKey) => SUBMISSION_WEEK_KEYS.includes(weekKey);
/** Upload constraints (also enforced server-side). */
export const HOMEWORK_MAX_UPLOAD_BYTES = 25 * 1024 * 1024; // 25 MB
export const HOMEWORK_ALLOWED_EXT = ["pdf", "doc", "docx", "png", "jpg", "jpeg", "heic"];
const filename = z
    .string()
    .trim()
    .min(1)
    .max(200)
    .refine((n) => HOMEWORK_ALLOWED_EXT.includes((n.split(".").pop() ?? "").toLowerCase()), {
    message: "Unsupported file type",
});
/** POST /student/homework/{weekKey}/upload-url body. */
export const homeworkUploadUrlSchema = z.object({
    filename,
    contentType: z.string().trim().min(1).max(120),
});
/** POST /student/homework/{weekKey}/submit body (s3Key returned by upload-url). */
export const homeworkSubmitSchema = z.object({
    s3Key: z.string().trim().min(1).max(400),
    filename,
});
/**
 * PUT /admin/students/{id}/homework/{weekKey}/review body. One acknowledgement
 * per week (not per document): `reviewed: false` clears it. The optional note is
 * shown to the student.
 */
export const homeworkReviewSchema = z.object({
    reviewed: z.boolean(),
    note: z.string().trim().max(500).optional(),
});
//# sourceMappingURL=homework.js.map